(function () {
  'use strict';

  var EVENT_NAMES = [
    'pst_search_submitted',
    'pst_search_result_selected',
    'pst_configuration_started',
    'pst_configuration_completed',
    'pst_frame_design_viewed',
    'pst_configurator_opened',
    'pst_design_selected',
    'pst_colour_selected',
    'pst_size_selected',
    'pst_size_guide_opened',
    'pst_configuration_shared',
    'pst_setup_card_downloaded',
    'pst_add_to_cart_attempted',
    'pst_add_to_cart_succeeded',
    'pst_add_to_cart_failed',
    'pst_configuration_edited',
    'pst_bundle_attached',
    'pst_bundle_viewed',
    'pst_bundle_item_added',
    'pst_bundle_completed',
    'pst_free_shipping_progress_seen',
    'pst_free_shipping_unlocked',
    'pst_gift_progress_seen',
    'pst_gift_unlocked',
    'pst_gift_configuration_started',
    'pst_gift_removed_below_threshold',
    'pst_upsell_impression',
    'pst_upsell_accepted',
    'pst_checkout_blocked_invalid_gift',
    'pst_product_media_viewed',
    'pst_product_detail_opened',
    'pst_product_help_clicked',
    'pst_application_density_selected',
    'pst_bundle_opened',
    'pst_bundle_tier_selected',
    'pst_bundle_component_added',
    'pst_bundle_component_removed',
    'pst_bundle_add_attempted',
    'pst_bundle_add_succeeded',
    'pst_bundle_add_failed',
    'pst_rider_profile_viewed',
    'pst_rider_setup_clicked',
    'pst_signature_collection_clicked',
    'pst_concierge_form_opened',
    'pst_concierge_form_attempted',
    'pst_concierge_form_succeeded',
    'pst_concierge_form_failed',
    'pst_retail_locator_viewed',
    'pst_retail_location_opened',
    'pst_retail_configurator_clicked',
    'pst_build_token_created',
    'pst_build_token_copied',
    'pst_build_token_opened',
    'pst_build_token_invalid',
    'pst_ugc_form_opened',
    'pst_ugc_form_attempted',
    'pst_ugc_form_succeeded',
    'pst_ugc_form_failed',
    'pst_waitlist_signup_succeeded'
  ];
  var ALLOWED_FIELDS = [
    'design_id',
    'colour_id',
    'kit_id',
    'product_id',
    'variant_id',
    'sku',
    'product_name',
    'currency',
    'price',
    'quantity',
    'value',
    'colour',
    'pack_style',
    'event_id',
    'source',
    'campaign',
    'affiliate_code',
    'product_type',
    'bundle_type',
    'error_code',
    'density_id',
    'page_type',
    'tier_id',
    'component_role',
    'rider_id',
    'partner_id',
    'location_id',
    'build_id',
    'token_version',
    'form_type',
    'result_count',
    'current_subtotal',
    'amount_to_threshold',
    'placement',
    'bundle_tier',
    'interaction_id'
  ];
  var emittedOnce = {};

  function pageType() {
    var body = document.body;
    return body && body.dataset ? cleanValue(body.dataset.template || '') : '';
  }

  function eventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (error) { /* use the non-identifying fallback */ }
    return 'pst_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function campaignToken(value) {
    return typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,79}$/.test(value) ? value : '';
  }

  function campaignUrl(destination, origin) {
    var source = new URL(origin || window.location.href);
    var target = new URL(destination, source);
    if (target.origin !== source.origin || !/^https?:$/.test(target.protocol)) return target.href;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'ttclid', 'ref', 'partner'].forEach(function (key) {
      var value = campaignToken(source.searchParams.get(key));
      if (value && !target.searchParams.has(key)) target.searchParams.set(key, value);
    });
    return target.href;
  }

  function analyticsAllowed() {
    try {
      return Boolean(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function cleanValue(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value !== 'string') return '';
    return value.replace(/[\r\n\t]/g, ' ').trim().slice(0, 120);
  }

  function sanitize(payload) {
    var safe = {};
    ALLOWED_FIELDS.forEach(function (key) {
      if (!payload || !Object.prototype.hasOwnProperty.call(payload, key)) return;
      var value = cleanValue(payload[key]);
      if (['source', 'campaign', 'affiliate_code', 'partner_id'].indexOf(key) !== -1) value = campaignToken(value);
      if (value !== '') safe[key] = value;
    });
    return safe;
  }

  function attribution() {
    var params = new URL(window.location.href).searchParams;
    return sanitize({
      source: campaignToken(params.get('utm_source')),
      campaign: campaignToken(params.get('utm_campaign')),
      affiliate_code: campaignToken(params.get('ref')),
      partner_id: campaignToken(params.get('partner') || params.get('utm_content'))
    });
  }

  function emit(name, payload, options) {
    if (EVENT_NAMES.indexOf(name) === -1 || !analyticsAllowed()) return false;
    var data = Object.assign({}, attribution(), sanitize(payload || {}));
    if (!data.event_id) data.event_id = eventId();
    if (!data.page_type) data.page_type = pageType();
    var onceKey = options && options.onceKey;
    if (onceKey) {
      var fingerprint = name + ':' + cleanValue(onceKey);
      if (emittedOnce[fingerprint]) return false;
      emittedOnce[fingerprint] = true;
    }

    var detail = { name: name, payload: data, occurred_at: new Date().toISOString() };
    window.PSTAnalyticsQueue = window.PSTAnalyticsQueue || [];
    window.PSTAnalyticsQueue.push(detail);
    if (window.PSTAnalyticsQueue.length > 100) window.PSTAnalyticsQueue.shift();
    document.dispatchEvent(new CustomEvent('pst:analytics', { detail: detail }));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        var publication = window.Shopify.analytics.publish(name, data);
        if (publication && typeof publication.catch === 'function') publication.catch(function () {});
      } catch (error) { /* The local event remains available. */ }
    }
    return true;
  }

  window.PSTAnalytics = {
    allowedEvents: EVENT_NAMES.slice(),
    allowedFields: ALLOWED_FIELDS.slice(),
    attribution: attribution,
    campaignUrl: campaignUrl,
    analyticsAllowed: analyticsAllowed,
    emit: emit,
    sanitize: sanitize
  };
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) document.dispatchEvent(new CustomEvent('pst:privacy-ready'));
    });
  }
  if (document.addEventListener) document.addEventListener('visitorConsentCollected', function () {
    if (!analyticsAllowed()) {
      window.PSTAnalyticsQueue = [];
      emittedOnce = {};
    }
  });
})();
